/**
 * 서버 문서 조회 유틸리티 (Feature 326: ItemId 매핑용)
 */
import { ApolloClient } from "@apollo/client";
import { createLogger } from "@ict/shared";
import { MACHINE_DOCUMENT_QUERY } from "@/lib/graphql/equipment";

const logger = createLogger({ module: "FetchMachineDocument" });

export async function fetchMachineDocument(
  apolloClient: ApolloClient<unknown>,
  projectId: string,
  docKey: string,
  machineId: string
) {
  try {
    const { data } = await apolloClient.query({
      query: MACHINE_DOCUMENT_QUERY,
      variables: { projectId, docKey, machineId },
      fetchPolicy: "network-only",
    });

    const doc = data?.machineDocument;
    if (!doc) {
      logger.error("MachineDocument를 찾을 수 없음");
      return { checkList: [], dataList: [], maintenance: [] };
    }

    return {
      checkList: doc.checkList || [],
      dataList: doc.dataList || [],
      maintenance: doc.maintenance || [],
    };
  } catch (error) {
    logger.error("설비 문서 조회 실패", error);
    return { checkList: [], dataList: [], maintenance: [] };
  }
}
